/* eslint-disable react/jsx-filename-extension */
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'M PLUS Rounded 1c';
    src: url(/fonts/MPLUSRounded1c-Regular.woff2) format('woff2');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'M PLUS Rounded 1c';
    src: url(/fonts/MPLUSRounded1c-Medium.woff2) format('woff2');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'M PLUS Rounded 1c';
    src: url(/fonts/MPLUSRounded1c-Bold.woff2) format('woff2');
    font-weight: 700;
    font-style: normal;
  }
  

  body {
    margin: 0;
    padding: 0;
    font-family: 'M PLUS Rounded 1c';
    background-color: ${({ theme }) => theme.colors.background};
  }
`
